import { defineStore } from 'pinia'

import type { ApiTokensStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useApiTokensStore = defineStore('api-tokens', {
  state: (): ApiTokensStore => ({
    loading: false,
    filterUserId: null,
    filterSearch: null,
    tokensPaginatedData: null,
    isModalCreate: false,
    createdPlainTextToken: null,
    tokenToEdit: null,
    tokenToDelete: null,
  }),
  actions,
  getters,
})
